<script>
import axios from 'axios'
import Layout from '../../../layouts/auth'
import appConfig from '@/app.config'
import OtpInput from '@/components/otp'
import { EMAIL_TO, OTP_CHECK } from '@/services/api/auth'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import VueHcaptcha from '@hcaptcha/vue-hcaptcha'

export default {
  page: {
    title: 'Lupa Kata Sandi',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    OtpInput,
    VueHcaptcha,
  },
  mixins: [Helper],
  data() {
    return {
      email: localStorage.getItem('emailOTP'),
      resend: false,
      timer: 0,
      otp: null,
      otpError: false,
      otpEmpty: false,
      otpWrong: false,
      isCaptchaVerified: false,
      hcaptcha_token_response: null,
      siteKey: process.env.VUE_APP_HCAPTCHA_SITEKEY,
    }
  },
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
  },
  created() {
    if (localStorage.getItem('timerOTP')) {
      const now = moment().toISOString()
      if (moment(now).isSameOrBefore(localStorage.getItem('timerOTP'), 'minute')) {
        this.timer = parseInt(moment(localStorage.getItem('timerOTP')).diff(now, 'minute'))
        this.resend = true
        this.countDownTimer()
      } else {
        this.resend = false
        localStorage.removeItem('timerOTP')
        this.timer = 0
      }
    }
  },
  mounted() {
    this.adjustImageSize()
  },
  methods: {
    async submitOTP() {
      if (this.otp != null) {
        if (this.otp.toString().length == 0) {
          this.otpError = true
          this.otpEmpty = true
        } else {
          const ipFetch = await axios.get('https://api.ipify.org?format=json')
          const remoteIp = ipFetch.data.ip
          const input = {
            email: this.email,
            otp: this.otp,
            hcaptcha_token_response: this.hcaptcha_token_response,
            remoteip: remoteIp,
          }
          this.$apollo
            .mutate({
              client: 'clientRateLimit',
              mutation: OTP_CHECK,
              variables: {
                input: input,
              },
            })
            .then((response) => {
              if (
                response.data.checkingOtpPassword.checkingOtpPassword.message ==
                'failed otp password'
              ) {
                this.resetCaptcha()
                this.$mcToast.error(this.$t('forgotPassword.alert.errorVC'))
                this.otpError = true
                this.otpWrong = true
              } else {
                this.$mcToast.success(this.$t('forgotPassword.alert.successVC'))
                localStorage.setItem('otpCode', this.otp)
                this.$store.commit('resetPassword/SET_OTP', this.otp)
                this.$router.push({ name: 'Reset Password' })
              }
            })
        }
      } else {
        this.otpError = true
        this.otpEmpty = true
      }
    },
    handleOnComplete(value) {
      this.otp = value
      this.otpError = false
      this.otpEmpty = false
    },
    handleOnChange(value) {
      this.otp = value
      if (this.otp == null) this.otpError = true
      this.otpError = false
      this.otpEmpty = false
      this.otpWrong = false
    },
    countDownTimer() {
      if (this.timer > 0) {
        setTimeout(() => {
          this.timer -= 1
          this.countDownTimer()
        }, 60000)
      } else {
        this.resend = false
        this.timer = 15
      }
    },
    resendOTP() {
      this.resend = true
      this.otpError = false
      const input = {
        email: this.email,
        hcaptcha_token_response: this.hcaptcha_token_response,
        remoteip: window.location.hostname,
      }
      this.$apollo
        .mutate({
          mutation: EMAIL_TO,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (
            response.data.emailForgotPassword.emailForgotPassword.message == 'failed to get email'
          ) {
            this.resetCaptcha()
            this.$mcToast.error(this.$t('forgotPassword.alert.errorEmail'))
          } else {
            localStorage.setItem('timerOTP', moment().add(15, 'minute').toISOString())
            this.timer = 15
            this.resend = true
            this.countDownTimer()
          }
        })
    },
    adjustImageSize() {
      this.resizeImage(this.$refs.imgPrimaryLogo, 45, 150)
      this.resizeImage(this.$refs.imgCopyrightLogo, 15, 50)
    },
    resetCaptcha() {
      this.isCaptchaVerified = false
      this.hcaptcha_token_response = null
      // Reset the captcha using the component's reset method
      this.$refs.captcha.reset()
    },
    onVerify(token) {
      this.isCaptchaVerified = true
      this.hcaptcha_token_response = token
    },
    onExpire() {
      // Handle captcha expiration
      this.resetCaptcha()
    },
    onChallengeExpire() {
      // Handle challenge expiration
      this.resetCaptcha()
    },
    onError(err) {
      // Handle captcha error
      this.resetCaptcha()
    },
  },
}
</script>
<template>
  <Layout>
    <div class="mc-auth__form">
      <h1 class="mc-auth__logo mb-0 pt-5">
        <router-link to="/">
          <img :src="getAsset('primaryLogo', 'login')" alt ref="imgPrimaryLogo" />
        </router-link>
      </h1>
      <div class="mc-auth__form-wrapper mc-auth__form-wrapper--forgot">
        <h4 class="mc-auth__label">{{ $t('forgotPassword.input.verificationCode') }}</h4>
        <p class="mb-1">{{ $t('forgotPassword.alert.inputVC') }}</p>
        <p>
          <strong>{{ email }}</strong>
        </p>
        <b-form-group
          class="mb-3"
          id="input-group-1"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            type="text"
            :placeholder="$t('forgotPassword.input.verificationCode')"
            :class="{
              'is-invalid': otpError,
            }"
            @change="handleOnChange"
          />
          <div class="mt-3">
            <vue-hcaptcha
              ref="captcha"
              :sitekey="siteKey"
              @verify="onVerify"
              @expired="onExpire"
              @challenge-expired="onChallengeExpire"
              @error="onError"
              language="id"
            />
          </div>
        </b-form-group>
        
        <div v-if="otpError" class="invalid-feedback d-flex justify-content-center mt-2">
          <span v-if="otpEmpty">{{ $t('forgotPassword.alert.cannotEmpty') }}</span>
          <span v-if="otpWrong">{{ $t('forgotPassword.alert.wrongVC') }}</span>
        </div>
        <div class="mt-5">
          <b-button
            :disabled="!otp || !isCaptchaVerified"
            type="submit"
            variant="primary"
            class="w-100"
            @click="submitOTP"
          >
            {{ $t('forgotPassword.action.verification') }}
          </b-button>
          <a v-if="resend" class="text-secondary d-block my-3">
            {{ $t('forgotPassword.action.resendIn') }} {{ timer }}
            {{ $t('global.time.minutes') }}
          </a>
          <a class="text-primary mt-3 d-block" @click="resendOTP" v-else>
            {{ $t('forgotPassword.action.resend') }}
          </a>
          <p class="mt-5">
            {{ $t('forgotPassword.label.wrongEmail') }}
            <a class="text-primary" @click="$router.push({ name: 'Forgot Password' })">
              {{ $t('forgotPassword.action.previous') }}
            </a>
          </p>
        </div>
      </div>
      <div class="mc-auth__copyright">
        <span
          :hidden="
            getAsset('copyrightLogo', 'general') == null ||
            getAsset('copyrightLogo', 'general') == ''
          "
        >
          {{ $t('login.text.presented') }}
          <img
            :src="getAsset('copyrightLogo', 'general')"
            alt
            class="ms-2"
            ref="imgCopyrightLogo"
          />
        </span>
      </div>
    </div>
  </Layout>
</template>
